

import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from 'firebase/messaging';


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDTbhEiZeNi8Hh6LFnonwpehr-R7EiDyz8",
  authDomain: "liretaproject.firebaseapp.com",
  projectId: "liretaproject",
  storageBucket: "liretaproject.appspot.com",
  messagingSenderId: "737645588803",
  appId: "1:737645588803:web:38c415d7d3d3b15c63fff6"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
export { firebaseApp, messaging };